import Vue from "vue";
import VueRouter from "vue-router";
import AuthCodeCallback from "../views/AuthCodeCallback.vue";
import Home from "../views/Home.vue";
// import HomeOld from "../views/HomeOld.vue";

Vue.use(VueRouter);

const routes = [
  {
    // Document title tag
    // We combine it with defaultDocumentTitle set in `src/main.js` on router.afterEach hook
    meta: {
      title: "Auth-Code-Callback",
      isPubliclyAccessible: true
    },
    path: "/auth/callback",
    name: "Auth-Code-Callback",
    component: AuthCodeCallback
  },
  {
    // Document title tag
    // We combine it with defaultDocumentTitle set in `src/main.js` on router.afterEach hook
    meta: {
      title: "Dashboard"
    },
    path: "/",
    name: "home",
    component: Home
  },
  {
    meta: {
      title: "Uploaded Data"
    },
    path: "/dashboard/uploaded-data",
    name: "dashboard.uploadedData",
    component: () => import("../views/ExternalUser/UploadDataView.vue")
  },
  {
    meta: {
      title: "Reporting Tracker"
    },
    path: "/reportingtracker",
    name: "reportingtracker",
    component: () => import("../views/ReportingTracker/List.vue")
  },
  {
    meta: {
      title: "Products | CustomerSpecific"
    },
    path: "/datamanagement/products/:customerId",
    name: "datamanagement.product",
    component: () => import("../views/DataManagement/Products.vue")
  },
  {
    meta: {
      title: "Certificates"
    },
    path: "/datamanagement/certificates/",
    name: "datamanagement.certificates",
    component: () => import("../views/DataManagement/CertificatesList.vue")
  },
  {
    meta: {
      title: "Products"
    },
    path: "/datamanagement/products/",
    name: "datamanagement.products",
    component: () => import("../views/DataManagement/Products.vue")
  },
  {
    meta: {
      title: "Import"
    },
    path: "/datamanagement/import",
    name: "datamanagement.import",
    component: () => import("../views/DataManagement/Import.vue")
  },
  {
    meta: {
      title: "Import Raw Data"
    },
    path: "/datamanagement/importRawData",
    name: "datamanagement.importRawData",
    component: () => import("../views/DataManagement/ImportRawData.vue")
  },
  {
    meta: {
      title: "Central Matching Report"
    },
    path: "/datamanagement/barcodeMatching",
    name: "datamanagement.barcodeMatching",
    component: () => import("../views/DataManagement/BarcodeMatching.vue")
  },
  {
    meta: {
      title: "Import Raw Data Form"
    },
    path: "/datamanagement/importRawDataForm",
    name: "datamanagement.importRawDataForm",
    component: () => import("../views/DataManagement/ImportRawDataForm.vue")
  },
  {
    meta: {
      title: "View Raw Data"
    },
    path: "/datamanagement/viewRawData/:id",
    name: "datamanagement.viewRawData",
    component: () => import("../views/DataManagement/ViewRawData.vue")
  },
  {
    meta: {
      title: "Import Form"
    },
    path: "/datamanagement/importform",
    name: "datamanagement.importform",
    component: () => import("../views/DataManagement/ImportForm.vue")
  },
  {
    meta: {
      title: "Transactions | CustomerSpecific"
    },
    path: "/datamanagement/transactions/:customerId",
    name: "datamanagement.transaction",
    component: () => import("../views/DataManagement/Transactions.vue")
  },
  {
    meta: {
      title: "Transactions"
    },
    path: "/datamanagement/transactions/",
    name: "datamanagement.transactions",
    component: () => import("../views/DataManagement/Transactions.vue")
  },
  {
    meta: {
      title: "Validation | Product"
    },
    path: "/datamanagement/validation/product/:id",
    name: "datamanagement.validation.product",
    component: () => import("../views/DataManagement/Validation.vue")
  },
  {
    meta: {
      title: "Validation | Transaction"
    },
    path: "/datamanagement/validation/transaction/:id",
    name: "datamanagement.validation.transaction",
    component: () => import("../views/DataManagement/Validation.vue")
  },
  {
    meta: {
      title: "Reporting Tracker | Add"
    },
    path: "/reportingtracker/add",
    name: "reportingtracker.add",
    component: () => import("../views/ReportingTracker/Add.vue")
  },
  {
    meta: {
      title: "Reporting Tracker | Edit"
    },
    path: "/reportingtracker/edit/:id",
    name: "reportingtracker.edit",
    component: () => import("../views/ReportingTracker/Edit.vue")
  },
  {
    meta: {
      title: "Reporting Tracker | View"
    },
    path: "/reportingtracker/view/:id",
    name: "reportingtracker.view",
    component: () => import("../views/ReportingTracker/Edit.vue")
  },
  {
    meta: {
      title: "Reporting Tracker | Country Overview Support"
    },
    path: "/reportingTracker/country-overview",
    name: "reportingTracker.countryOverview",
    component: () =>
      import("../views/ReportingTracker/CountrySupportOverview.vue")
  },
  {
    meta: {
      title: "Reporting Tracker | CAM Support Overview"
    },
    path: "/reportingTracker/CAM-support-overview",
    name: "reportingTracker.CAMSupportOverview",
    component: () => import("../views/ReportingTracker/CAMSupportOverview.vue")
  },
  {
    meta: {
      title: "Reporting Tracker | Message Configurator"
    },
    path: "/reportingTracker/message-configurator",
    name: "reportingTracker.messageConfigurator",
    component: () => import("../views/ReportingTracker/MessageConfigurator.vue")
  },
  {
    meta: {
      title: "Customer Updates | Add"
    },
    path: "/reportingTracker/customer/update",
    name: "reportingTracker.customerUpdates",
    component: () => import("../views/ReportingTracker/CustomerUpdatesAdd.vue")
  },
  {
    meta: {
      title: "Customer Updates"
    },
    path: "/reportingTracker/customer/updates",
    name: "reportingTracker.customerUpdates1",
    component: () => import("../views/ReportingTracker/CustomerUpdatesList.vue")
  },
  {
    meta: {
      title: "Customer Updates | Edit"
    },
    path: "/reportingtracker/customer/updates/edit/:id",
    name: "reportingtracker.customerUpdateEdit",
    component: () => import("../views/ReportingTracker/CustomerUpdatesEdit.vue")
  },
  {
    meta: {
      title: "Customer Updates | View"
    },
    path: "/reportingtracker/customer/updates/view/:id",
    name: "reportingtracker.customerUpdateView",
    component: () => import("../views/ReportingTracker/CustomerUpdatesEdit.vue")
  },
  {
    meta: {
      title: "Customer Updates | View"
    },
    path: "/reportingtracker/customerupdates/view/:id",
    name: "reportingtracker.customerUpdateViewFromDashboard",
    component: () =>
      import("../views/ReportingTracker/CustomerUpdatesEdit.vue"),
    props: { isFromDashboard: true }
  },
  {
    meta: {
      title: "Analytics"
    },
    path: "/analytics",
    name: "analytics",
    component: () => import("../views/Analytics.vue")
  },
  {
    meta: {
      title: "Survey Overview"
    },
    path: "/survey/overview",
    name: "survey.overview",
    component: () => import("../views/Survey/SurveyOverview.vue")
  },
  {
    meta: {
      title: "Survey"
    },
    path: "/survey",
    name: "survey",
    component: () => import("../views/Survey/Survey.vue")
  },
  {
    meta: {
      title: "Playground"
    },
    path: "/playground",
    name: "playground",
    component: () => import("../views/Compliance/PlaygroundList.vue")
  },
  {
    meta: {
      title: "Compliance"
    },
    path: "/compliance",
    name: "compliance",
    component: () => import("../views/Compliance/Dashboard.vue"),
    props: {
      headerText: "overview"
    }
  },
  {
    meta: {
      title: "Compliance By Country"
    },
    path: "/compliance/country",
    name: "compliance.country",
    component: () => import("../views/Compliance/Dashboard.vue"),
    props: {
      headerText: "country"
    }
  },
  {
    meta: {
      title: "Compliance By Stream"
    },
    path: "/compliance/stream",
    name: "compliance.stream",
    component: () => import("../views/Compliance/Dashboard.vue"),
    props: {
      headerText: "stream"
    }
  },
  {
    meta: {
      title: "Compliance By Scheme"
    },
    path: "/compliance/scheme",
    name: "compliance.scheme",
    component: () => import("../views/Compliance/Dashboard.vue"),
    props: {
      headerText: "scheme"
    }
  },
  {
    meta: {
      title: "Compliance By Product"
    },
    path: "/compliance/product",
    name: "compliance.product",
    component: () => import("../views/Compliance/Dashboard.vue"),
    props: {
      headerText: "product"
    }
  },
  {
    meta: {
      title: "Compliance By Stream -WEEE"
    },
    path: "/compliance/stream/weee",
    name: "compliance.stream.weee",
    component: () => import("../views/Compliance/Dashboard.vue"),
    props: {
      headerText: "weee"
    }
  },
  {
    meta: {
      title: "Compliance By Stream -Battery"
    },
    path: "/compliance/stream/batt",
    name: "compliance.stream.batt",
    component: () => import("../views/Compliance/Dashboard.vue"),
    props: {
      headerText: "batt"
    }
  },
  {
    meta: {
      title: "Compliance By Stream -Packaging"
    },
    path: "/compliance/stream/pack",
    name: "compliance.stream.pack",
    component: () => import("../views/Compliance/Dashboard.vue"),
    props: {
      headerText: "pack"
    }
  },
  {
    meta: {
      title: "Compliance By Stream -Paper (Non-Packaging)"
    },
    path: "/compliance/stream/paper",
    name: "compliance.stream.paper",
    component: () => import("../views/Compliance/Dashboard.vue"),
    props: {
      headerText: "paper"
    }
  },
  {
    meta: {
      title: "Compliance By Stream -SUP(Single Use Plastic)"
    },
    path: "/compliance/stream/sup",
    name: "compliance.stream.sup",
    component: () => import("../views/Compliance/Dashboard.vue"),
    props: {
      headerText: "sup"
    }
  },
  {
    meta: {
      title: "Compliance By Stream -Textiles"
    },
    path: "/compliance/stream/textiles",
    name: "compliance.stream.textiles",
    component: () => import("../views/Compliance/Dashboard.vue"),
    props: {
      headerText: "textiles"
    }
  },
  {
    meta: {
      title: "Customers"
    },
    path: "/customers",
    name: "customers",
    component: () => import("../views/Customers/List.vue")
  },
  {
    meta: {
      title: "Customers | Add"
    },
    path: "/customers/add",
    name: "customers.add",
    component: () => import("../views/Customers/Edit.vue")
  },
  {
    meta: {
      title: "Customers | View"
    },
    path: "/customers/view/:id",
    name: "customers.view",
    component: () => import("../views/Customers/Edit.vue")
  },
  {
    meta: {
      title: "Customers | Edit"
    },
    path: "/customers/edit/:id",
    name: "customers.edit",
    component: () => import("../views/Customers/Edit.vue")
  },
  {
    meta: {
      title: "Customer Reminders"
    },
    path: "/customer/reminders/:id",
    name: "customer.reminder",
    component: () => import("../views/Customers/Reminder.vue")
  },
  {
    meta: {
      title: "Scopes"
    },
    path: "/rulesManager/scopes/",
    name: "rulesManager.scopes",
    component: () => import("../views/RulesManager/Scopes.vue")
  },
  {
    meta: {
      title: "Report Definitions"
    },
    path: "/rulesManager/reportDefinitions/",
    name: "rulesManager.reportDefinitions",
    component: () => import("../views/RulesManager/ReportDefinitions.vue")
  },
  {
    meta: {
      title: "Rules List"
    },
    path: "/rulesManager/rulesList/",
    name: "rulesManager.rulesList",
    component: () => import("../views/RulesManager/RulesList.vue")
  },
  {
    meta: {
      title: "Scope Definition"
    },
    path: "/rulesManager/scopeDefinition/",
    name: "rulesManager.scopeDefinition",
    component: () => import("../views/RulesManager/ScopeDefinition.vue")
  },
  {
    meta: {
      title: "Scope | edit"
    },
    path: "/rulesManager/scopeDefinition/:id",
    name: "rulesManager.scope.edit",
    component: () => import("../views/RulesManager/ScopeDefinition.vue"),
    props: { isViewOnly: false }
  },
  {
    meta: {
      title: "Scope | view"
    },
    path: "/rulesManager/scopeDefinition/:id/view",
    name: "rulesManager.scope.view",
    component: () => import("../views/RulesManager/ScopeDefinitionView.vue"),
    props: { isViewOnly: true }
  },
  {
    meta: {
      title: "Report Definition"
    },
    path: "/rulesManager/reportDefinition/",
    name: "rulesManager.reportDefinition",
    component: () => import("../views/RulesManager/ReportDefinition.vue")
  },
  {
    meta: {
      title: "Report Definition | copy"
    },
    path: "/rulesManager/reportDefinition/copy",
    name: "rulesManager.reportDefinition.copy",
    component: () => import("../views/RulesManager/ReportDefinitionCopy.vue")
  },
  {
    meta: {
      title: "Report Definition | Tabular Form"
    },
    path: "/rulesManager/tabularReportDefinition",
    name: "rulesManager.tabularReportDefinition",
    component: () => import("../views/RulesManager/ReportDefinitionTabular.vue")
  },
  {
    meta: {
      title: "Report Definition | Tabular Form"
    },
    path: "/rulesManager/tabularReportDefinition/:id",
    name: "rulesManager.tabularReportDefinition",
    component: () => import("../views/RulesManager/ReportDefinitionTabular.vue")
  },
  {
    meta: {
      title: "Report Definition | Tabular Form View"
    },
    path: "/rulesManager/tabularReportDefinition/:id/view",
    name: "rulesManager.tabularReportDefinition.view",
    component: () =>
      import("../views/RulesManager/ReportDefinitionTabular.vue"),
    props: { isViewOnly: true }
  },
  {
    meta: {
      title: "Report Definition | Tabular Form View"
    },
    path: "/rulesManager/tabularReportDefinition/:id/definition-view",
    name: "rulesManager.tabularReportDefinition.definition-view",
    component: () =>
      import("../views/RulesManager/ReportDefinitionTabular.vue"),
    props: { isViewOnly: true, isDefinitionView: true }
  },
  {
    meta: {
      title: "Report Definition | edit"
    },
    path: "/rulesManager/reportDefinition/:id",
    name: "rulesManager.reportDefinition.edit",
    component: () => import("../views/RulesManager/ReportDefinition.vue"),
    props: { isViewOnly: false }
  },
  {
    meta: {
      title: "Report Definition | view"
    },
    path: "/rulesManager/reportDefinition/:id/view",
    name: "rulesManager.reportDefinition.view",
    component: () => import("../views/RulesManager/ReportDefinitionView.vue"),
    props: { isViewOnly: true }
  },
  {
    meta: {
      title: "Report Definition | definition view"
    },
    path: "/rulesManager/reportDefinition/:id/definition-view",
    name: "rulesManager.reportDefinition.definition-view",
    component: () =>
      import("../views/RulesManager/OldReportDefinitionView.vue"),
    props: { isViewOnly: true }
  },
  {
    meta: {
      title: "Reports List"
    },
    path: "/reportManager/reportsList/",
    name: "reportManager.reportsList",
    component: () => import("../views/ReportManager/ReportsList.vue")
  },
  {
    meta: {
      title: "Testing List"
    },
    path: "/reportManager/testingList/",
    name: "reportManager.testingList",
    component: () => import("../views/ReportManager/TestingList.vue")
  },
  {
    meta: {
      title: "Testing List | view"
    },
    path: "/reportManager/testingList/view/:id",
    name: "reportManager.testingList.view",
    component: () => import("../views/ReportManager/TestingListView.vue")
  },
  {
    meta: {
      title: "Reporting List | view"
    },
    path: "/reportManager/reportList/view/:id",
    name: "reportManager.reportList.view",
    component: () => import("../views/ReportManager/ReportListView.vue")
  },
  {
    meta: {
      title: "NotFound"
    },
    path: "*",
    name: "notFound",
    component: () => import("../views/NotFound.vue")
  },
  {
    meta: {
      title: "Suppliers"
    },
    path: "/suppliers/",
    name: "suppliers",
    component: () => import("../views/Suppliers/SuppliersList.vue")
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
export default router;
